import { Autocomplete, type AutocompleteProps } from "@mantine/core"
import uniq from "lodash/uniq"
import { useUsers } from "@/hooks"

export function PositionInput(props: Omit<AutocompleteProps, "data">) {
  const { users } = useUsers()
  const data = uniq(users?.map((user) => user.position).filter((p): p is string => !!p))

  return (
    <Autocomplete
      {...props}
      data={data}
      placeholder="Position"
      selectFirstOptionOnChange
      comboboxProps={{
        withinPortal: true,
      }}
    />
  )
}
